import { GlobalOutlined } from '@ant-design/icons';
import { Button, Form, Input, Space, Tooltip } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';

import { useAppDispatch } from '../hooks/use-app-dispatch';
import { type RootState } from '../reducers';
import { ebayGetUserUrl, ebayUserCode } from '../reducers/ebay/reducer';
import { SPACING } from '../theme/tokens';

function EbayContainer(): React.ReactElement {
  const dispatch = useAppDispatch();
  const ebayUserUrl = useSelector((s: RootState) => s.Ebay.userUrl);
  const ebayInProcess = useSelector((s: RootState) => s.Ebay.inProcess);

  const onFinishUrl = (values: { url: string }): void => {
    const url = new URL(values.url);

    const code = url.searchParams.get('code');

    if (code) {
      dispatch(ebayUserCode(code));
    }
  };

  if (ebayUserUrl) {
    return (
      <Space size={SPACING.lg} align="start">
        <Tooltip title="Get URL for pair with account">
          <a
            href={ebayUserUrl}
            target="_blank"
            rel="noreferrer noopener nofollow"
          >
            <Button size="large" color="primary" disabled={ebayInProcess}>
              Go to ebay
            </Button>
          </a>
        </Tooltip>

        <Form onFinish={onFinishUrl}>
          <Form.Item name="url">
            <Input
              size="large"
              placeholder="Insert URL from ebay"
              prefix={<GlobalOutlined />}
            />
          </Form.Item>

          <Button
            size="large"
            color="primary"
            type="primary"
            htmlType="submit"
            disabled={ebayInProcess}
            loading={ebayInProcess}
          >
            Save
          </Button>
        </Form>
      </Space>
    );
  }

  return (
    <Space size={SPACING.lg} align="start">
      <Tooltip title="Get URL for pair with account">
        <Button
          size="large"
          color="primary"
          onClick={() => {
            dispatch(ebayGetUserUrl());
          }}
          disabled={ebayInProcess}
        >
          Pair with ebay account
        </Button>
      </Tooltip>
    </Space>
  );
}

export default EbayContainer;
